import * as React from "react";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "rc-slider/assets/index.css";
import { VapeWrap } from "./VapeView";
import Select, {components} from 'react-select';
import SliderComp from "./SliderComp";
import alcoholIcon from "../resources/alcohol.svg";
import partnerIcon from "../resources/common_partner.svg";
import Tick from '../resources/tick.svg';
import TickFilled from '../resources/tick_filled.svg';
import CrossFilled from '../resources/cross_filled.svg';
import Cross from '../resources/cross.svg';
import Alcohol from '../resources/alcohol-mi2.svg';
import Heart from '../resources/heart-mi2.svg';

export const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props} >
        <span style={{ fontSize: '11px', lineHeight: '4px', marginLeft: '-6px'}}>&#9660;</span>
      </components.DropdownIndicator>
    );
  };

  export const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '5px', // Adjust border radius as needed
      borderColor: '#93B3FC', // Border color of the select box
      minHeight: '20px',
        height: '30px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
        width: '250px'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#93B3FC',
      height: '5px',
      width: '5px',
       // Color of the dropdown indicator triangle
    }),
  };

const AlcoholIntercourseView = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const divRef = useRef(null);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        {
          threshold: 0.1, // Adjust this value as needed
        }
      );
  
      if (divRef.current) {
        observer.observe(divRef.current);
      }
  
      return () => {
        if (divRef.current) {
          observer.unobserve(divRef.current);
        }
      };
    }, []);

      const [answersYouth, setAnswersYouth] = React.useState([999, 999]);
      const [inputTextAnswer, setInputTextAnswer] = React.useState("");

      const [adultAnswers, setAdultAnswers] = React.useState([999, 999, 999, 999, 999, 999, 999, 999, 999, 999]);
      const [answersCommon, setAnswersCommon] = React.useState([999, 999]);

      React.useEffect(() => {
        // const filteredAnswers = answers.filter(value => value === 999);
        if (props.age < 18) {
            if (
                answersYouth[0] !== 999 &&
                answersYouth[1] !== 999 &&
                answersCommon[0] !== 999 &&
                answersCommon[1] !== 999
              ) {
                let data = {
                    YOUTH_SEXPARTNERS: answersYouth[0],
                    YOUTH_UNPSEX: answersYouth[1],
                    SEXPARTNERS: 98,
                    PARTNER_MALE: 98,
                    PARTNER_FEMALE: 98,
                    PARTNER_TRANS: 98,
                    PARTNER_MONO: 98,
                    PARTNER_MULTI: 98,
                    PARTNER_HIV: 98,
                    PARTNER_HCV: 98,
                    PARTNER_PWID: 98,
                    PARTNER_MSM: 98,
                    SEXACT3_SF : answersCommon[0],
                    SEXACT4_SF : answersCommon[1],

                }
                props.setAlcoholIntercourseInfoData(data);
                props.setNextButton(true);
                props.onAllAnswered(false);
            } else {
                props.setNextButton(false);
            }
        } else {
            const filteredAnswers = adultAnswers.filter(value => value === 999);
        if (
           filteredAnswers.length === 0 &&
           answersCommon[0] !== 999 &&
           answersCommon[1] !== 999
           )
 {
                let data = {
                    YOUTH_SEXPARTNERS: 98,
                    YOUTH_UNPSEX: 98,
                    SEXPARTNERS: adultAnswers[0],
                    PARTNER_MALE: adultAnswers[1],
                    PARTNER_FEMALE: adultAnswers[2],
                    PARTNER_TRANS: adultAnswers[3],
                    PARTNER_MONO: adultAnswers[4],
                    PARTNER_MULTI: adultAnswers[5],
                    PARTNER_HIV: adultAnswers[6],
                    PARTNER_HCV: adultAnswers[7],
                    PARTNER_PWID: adultAnswers[8],
                    PARTNER_MSM:  adultAnswers[9],
                    SEXACT3_SF : answersCommon[0],
                    SEXACT4_SF : answersCommon[1],
                }
                props.setAlcoholIntercourseInfoData(data);
                props.setNextButton(true);
                props.onAllAnswered(false);
            } else {
                props.setNextButton(false);
            }
        }
    }, [answersYouth, adultAnswers, answersCommon]);

    const handleAnswerChange = (index, value) => {
        // console.log("index", index, "value", value);
        const newAnswers = [...answersYouth];
        newAnswers[index] = value;
        setAnswersYouth(newAnswers);
    }

    const handleAdultAnswerChange = (index, value) => {
        // console.log("index", index, "value", value);
        const newAnswers = [...adultAnswers];
        newAnswers[index] = value;
        setAdultAnswers(newAnswers);
    }

    const handleCommonAnswerChange = (index, value) => {
        // console.log("index", index, "value", value);
        const newAnswers = [...answersCommon];
        newAnswers[index] = value;
        setAnswersCommon(newAnswers);
    }


    const question1options = [
        { value: 0, label: '0 people' },
        { value: 1, label: '1 person' },
        { value: 2, label: '2 people' },
        { value: 3, label: '3 people' },
        { value: 4, label: '4 people' },
        { value: 5, label: '5 people' },
        { value: 6, label: '6 people' },
        { value: 7, label: '7 people' },
        { value: 8, label: '8 people' },
        { value: 9, label: '9 people' },
        { value: 10, label: '10 or more people' },
    ];

    const questionYouth1Options = [
        { value: 0, label: '0 people' },
        { value: 1, label: '1 person' },
        { value: 2, label: '2 people' },
        { value: 3, label: '3 people' },
        { value: 4, label: '4 people' },
        { value: 5, label: '5 people' },
        { value: 6, label: '6 or more people' },
    ]

    const questionYouth2Options = [
        { value: 0, label: 'No' },
        { value: 1, label: 'Yes, unprotected oral sex' },
        { value: 2, label: 'Yes, unprotected vaginal sex' },
        { value: 3, label: 'Yes, unprotected anal sex' }
    ]

    const adultQuestions = [
        "A male?",
        "A female?",
        "A transgender individual?",
        "A significant other in a monogamous relationship?",
        "Multiple partners?",
        "An HIV positive person?",
        "A Hepatitis positive person?",
        "A person who injects drugs?",
        "A man who has sex with men?",
    ]

    // console.log("adult answers", adultAnswers)
    return(
        <VapeWrap>      
                <h2>Alcohol and Sex</h2>
                {props.age < 18 ? <>
                    <QuestionSection>
                        <div>
                        <QuestionNumber>
                            <span>1</span>
                        </QuestionNumber>
                        <p>During the past 3 months, how many people did you have sex with?</p>
                        </div>
                    <SliderComp min = {0} maxValue={30} icon={partnerIcon} handleAnswerChange={(value)=>handleAnswerChange(0, value)} index={0} answer={answersYouth[0]} showPlus={true} /> 
                    </QuestionSection>
                    <QuestionSection>
                        <div>
                        <QuestionNumber>
                            <span>2</span>
                        </QuestionNumber>
                        <p>In the last month, How many times did you consume alcohol before or during oral, anal, or vaginal sex?</p>
                        </div>
                        <SliderComp min = {0} maxValue={30} icon={alcoholIcon} handleAnswerChange={(value)=>handleCommonAnswerChange(0, value)} index={0} answer={answersCommon[0]}/> 

                    </QuestionSection>
                    <QuestionSection>
                        <div>
                        <QuestionNumber>
                            <span>3</span>
                        </QuestionNumber>
                        <p>During the times when you would consume alcohol before or during oral, anal, or vaginal sex, how many drinks, on average, did you consume?</p>
                        <SliderComp min = {0} maxValue={30} icon={alcoholIcon} handleAnswerChange={(value)=>handleCommonAnswerChange(1, value)} index={1} answer={answersCommon[1]}/> 
                        </div>
                    </QuestionSection>
                    <QuestionSection style={{color: (props.showUnanswered && (answersYouth[1] == 999)) ? 'red' : 'black'}}>
                        <div>
                        <QuestionNumber>
                            <span>4</span>
                        </QuestionNumber>
                        <p>During the past 30 days, have you had unprotected sex? If yes, select all that apply. (Unprotected sex, is vaginal, oral, or anal sex without a barrier such as a condom.)</p>
                        </div>
                        <Select 
                            options={questionYouth2Options}
                            isMulti
                            onChange={(op)=>handleAnswerChange(1, op.value)}
                            placeholder="Select an option"
                            customStyles={customStyles}
                            components={{ DropdownIndicator }}
                        />
                    </QuestionSection>
                </> : null}

                {props.age > 17 ? <>
                    <QuestionSection>
                        <div>
                        <QuestionNumber>
                            <span>1</span>
                        </QuestionNumber>
                        <div style={{display: 'flex', flexDirection: 'row'}}></div>
                        <p>During the past 30 days, how many sexual partners have you had? A sexual partner is someone with whom you have sex, that is, engage in sexual activity.</p>                      
                        <SliderComp min = {0} maxValue={30} icon={partnerIcon} handleAnswerChange={(value)=>handleAdultAnswerChange(0, value)} index={0} answer={adultAnswers[0]} showPlus={true}/> 
                        </div>
                    </QuestionSection>
                    <QuestionSection>
                        <div>
                        <QuestionNumber>
                            <span>2</span>
                        </QuestionNumber>
                        <p>In the last month, How many times did you consume alcohol before or during oral, anal, or vaginal sex?</p>
                        </div>
                        <SliderComp min = {0} maxValue={30} icon={alcoholIcon} handleAnswerChange={(value)=>handleCommonAnswerChange(0, value)} index={0} answer={answersCommon[0]}/> 

                    </QuestionSection>
                    <QuestionSection>
                        <div>
                        <QuestionNumber>
                            <span>3</span>
                        </QuestionNumber>
                        <p>During the times when you would consume alcohol before or during oral, anal, or vaginal sex, how many drinks, on average, did you consume?</p>
                        <SliderComp min = {0} maxValue={30} icon={alcoholIcon} handleAnswerChange={(value)=>handleCommonAnswerChange(1, value)} index={1} answer={answersCommon[1]}/> 
                        </div>
                    </QuestionSection>
                    <ImagesDiv ref={divRef}>
                        <img className={`heart ${isVisible ? "animate-heart" : ""}`} src={Heart} width={"7%"} />
                        <img className={`alcohol-img ${isVisible ? "animate-alcohol" : ""}`} src={Alcohol} width={"7%"} />
                    </ImagesDiv>
                    <QuestionSection>
                        <div>
                        <h3>During the past 30 days, have you had unprotected sex with…</h3>
                        <h4>(Unprotected sex is vaginal, oral, or anal sex without a barrier such as a condom or dental dam.)</h4>
                        </div>

                    </QuestionSection>
                    <div>
                    {adultQuestions.map((question, index)=> {
                        return <QuestionSection style={{color: (props.showUnanswered && (adultAnswers[index+1] == 999)) ? 'red' : 'black'}}>
                        <div>
                        <QuestionNumber>
                            <span>{index+4}</span>
                        </QuestionNumber>
                        <DataWrap>
                            <p style={{width: '90%'}}>{question}</p>
                            <div>
                                <img src={adultAnswers[index+1] == 1 ? TickFilled : Tick} width={40} height={40} onClick={() => handleAdultAnswerChange(index+1, 1)} />
                                <img src={adultAnswers[index+1] == 0 ? CrossFilled : Cross} width={35} height={40} onClick={() => handleAdultAnswerChange(index+1, 0)} />
                            </div>
                        </DataWrap>
                        </div>
                    </QuestionSection>

                    })}    
                    </div>
                    
                </> : null}
        </VapeWrap>
    );
}

const QuestionNumber = styled.div`
background-color: #4D71E5;
width: 20px;
height: 20px;
position: absolute;
    left: -40px;
    top: 10px;
border-radius: 50%;
font-size: 13px;
color: white;
display: flex;
justify-content: center;
span{
    align-self: center;
    margin-bottom: 0px;
}
`;

const DataWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    div{
        display: flex;
        align-items: center;
        width: 100px;
        justify-content: space-between;
    }
    img{
        cursor: pointer;
    }
`;

const ImagesDiv = styled.div`
position: relative;
height: 80px;
display: flex;
@keyframes heart-animation {
  0%   { left:1%;}
  50% { left: 48%}
  100% {left: 1%;}
}
@keyframes alcohol-animation {
  0%   { right: 1%;}
  50% { right: 48%}
  100% {right: 1%;}
}
.heart{
    position: absolute;
    left: 1%;
}
.alcohol-img{
    position: absolute;
    right: 1%;
}
.animate-heart{
    animation-name: heart-animation;
     animation-duration: 15s;
     /* animation-fill-mode: forwards; */
     animation-iteration-count: infinite;
}
.animate-alcohol{
    animation-name: alcohol-animation;
     animation-duration: 15s;
     /* animation-fill-mode: forwards; */
     animation-iteration-count: infinite;
}
@media only screen and (max-width: 576px) {
        height: 35px;
        img{
            width: 13%;
        }
    }
    @media only screen and (max-width: 768px) {
        height: 55px;
        img{
            width: 14%;
        }
    }
    @media only screen and (max-width: 1000px) {
        height: 70px;
        img{
            width: 12%;
        }
    }
    @media only screen and (max-width: 1300px) {
        height: 75px;
        img{
            width: 11%;
        }
    }
`;

const SelectWrap = styled.div`
    width: 250px;
    height: 42px;
>div>div{
    /* height: 25px; */
    font-size: 14px;
    align-content: center;
    >div:last-child{
        /* height: 35px; */
        span{
            display: none;
        }
    }
}
`;

const QuestionSection = styled.section`
width: 100%;
position: relative;
    margin: 20px 0;
    padding: 10px 0;
    h3{
        width: 75%;
        line-height: 2;
    }
`;

export default AlcoholIntercourseView;